export const ANGEL_CONTENT_STARTS = 'angel_content_starts'
export const ANGEL_PIF_CLAIM_FREE_TICKET = 'angel-pif-claim-free-ticket'
export const ANGEL_USER_FEATURE_INTRODUCTION = 'angel-user-feature-introduction'
export const GUILD_CONTINUE_WATCHING_COLLECTION = 'angel-guild-continue-watching-collection'
